
import React from 'react';
import LogoCarousel from './LogoCarousel';
import { Client } from './data/clientTypes';

interface TwoRowsLogoCarouselProps {
  clients: Client[];
  grayscale?: boolean;
}

const TwoRowsLogoCarousel: React.FC<TwoRowsLogoCarouselProps> = ({ 
  clients,
  grayscale = false 
}) => {
  // Divide clients into two groups for the two rows
  const halfwayIndex = Math.ceil(clients.length / 2);
  const firstRowClients = clients.slice(0, halfwayIndex);
  const secondRowClients = clients.slice(halfwayIndex);

  return (
    <div className="w-full space-y-6">
      {/* First row - left direction with slower speed */}
      <LogoCarousel 
        clients={firstRowClients} 
        direction="left" 
        speed={1}
        grayscale={grayscale}
      />
      
      {/* Second row - opposite direction (right) with slower speed */}
      <LogoCarousel 
        clients={secondRowClients} 
        direction="right" 
        speed={1}
        className="mt-4"
        grayscale={grayscale}
      />
    </div>
  );
};

export default TwoRowsLogoCarousel;
